import { execSync } from 'child_process';
import { existsSync, writeFileSync } from 'fs';
import { join } from 'path';
import { getCloudGridHome } from '../home.js';

const CLAUDE_CODE_DOCS_URL = 'https://code.claude.com/docs/en/overview';

export const CLAUDE_CODE_PRESENT_MSG =
  'Claude Code is installed. Build with claude and ship to CloudGrid — ask it to deploy a directory or drop a file.';

export const CLAUDE_CODE_MISSING_MSG =
  `Claude Code is not installed. It pairs with CloudGrid to build and ship from one place. Install: curl -fsSL https://claude.ai/install.sh | bash  (docs: ${CLAUDE_CODE_DOCS_URL}).`;

/**
 * Check whether the `claude` binary is on PATH. Non-blocking: returns false
 * (never throws) when the binary is absent or the lookup fails.
 */
export function isClaudeCodeInstalled(): boolean {
  try {
    execSync('claude --version', { stdio: 'pipe', timeout: 3000 });
    return true;
  } catch {
    return false;
  }
}

const NUDGE_BREADCRUMB = '.claude-code-nudge-shown';

/**
 * Returns true if the Claude Code nudge has already been shown.
 */
export function hasShownClaudeCodeNudge(): boolean {
  try {
    return existsSync(join(getCloudGridHome(), NUDGE_BREADCRUMB));
  } catch {
    return false;
  }
}

/**
 * Mark the Claude Code nudge as shown so it doesn't repeat.
 */
export function markClaudeCodeNudgeShown(): void {
  try {
    writeFileSync(join(getCloudGridHome(), NUDGE_BREADCRUMB), '', { flag: 'w' });
  } catch {
    // Non-fatal — worst case the nudge shows again next login.
  }
}
